declare namespace $ {

	type $mol_number__minimal_width_shm_hitalama_map_borderwidth_1 = $mol_type_enforce<
		number
		,
		ReturnType< $mol_number['minimal_width'] >
	>
	type $mol_number__value_shm_hitalama_map_borderwidth_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_borderwidth['border_width'] >
		,
		ReturnType< $mol_number['value'] >
	>
	type $mol_number__Dec_shm_hitalama_map_borderwidth_3 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_number['Dec'] >
	>
	type $mol_number__Inc_shm_hitalama_map_borderwidth_4 = $mol_type_enforce<
		any
		,
		ReturnType< $mol_number['Inc'] >
	>
	type $mol_view__sub_shm_hitalama_map_borderwidth_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_search__hint_shm_hitalama_map_borderwidth_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_search['hint'] >
	>
	type $mol_search__query_shm_hitalama_map_borderwidth_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_borderwidth['border_width_selected'] >
		,
		ReturnType< $mol_search['query'] >
	>
	type $mol_search__anchor_content_shm_hitalama_map_borderwidth_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_search['anchor_content'] >
	>
	type $mol_search__suggests_shm_hitalama_map_borderwidth_9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_borderwidth['border_width_suggests'] >
		,
		ReturnType< $mol_search['suggests'] >
	>
	export class $shm_hitalama_map_borderwidth extends $mol_view {
		border_width_selected( next?: string ): string
		border_width( next?: number ): number
		Border_width( ): $mol_number
		Border_width_wrap( ): $mol_view
		border_width_suggests( ): readonly(string)[]
		Search( ): $mol_search
		sub( ): readonly(any)[]
		border_width_options( ): readonly(number)[]
	}
	
}

//# sourceMappingURL=borderwidth.view.tree.d.ts.map